import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import CommunityStats from './components/CommunityStats';
import WelcomeBanner from './components/WelcomeBanner';
import Icon from '../../components/AppIcon';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      navigate('/event-discovery');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 lg:gap-12">
            {/* Left Column - Login Form */}
            <div className="flex flex-col justify-center">
              <div className="w-full max-w-md mx-auto">
                <div className="mb-6 md:mb-8 lg:mb-10">
                  <button
                    onClick={() => navigate('/event-discovery')}
                    className="inline-flex items-center gap-2 text-primary hover:text-secondary transition-smooth mb-6 md:mb-7 lg:mb-8">

                    <Icon name="ArrowLeft" size={20} />
                    <span className="text-sm md:text-base font-medium">Ana Sayfaya Dön</span>
                  </button>

                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2 md:mb-3">
                    Tekrar Hoş Geldiniz
                  </h2>
                  <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
                    SUP maceranıza devam etmek için giriş yapın
                  </p>
                </div>

                <div className="bg-card border border-border rounded-xl md:rounded-2xl lg:rounded-3xl p-6 md:p-8 lg:p-10 shadow-organic">
                  <LoginForm />
                </div>

                <div className="mt-6 md:mt-8 lg:mt-10">
                  <TrustSignals />
                </div>

                














              </div>
            </div>

            {/* Right Column - Welcome Banner & Stats */}
            <div className="hidden lg:flex flex-col justify-center gap-8 md:gap-10 lg:gap-12">
              <WelcomeBanner />
              <CommunityStats />
            </div>
          </div>

          {/* Mobile Stats Section */}
          <div className="lg:hidden mt-8 md:mt-10">
            <CommunityStats />
          </div>
        </div>
      </div>
      <footer className="border-t border-border bg-card mt-12 md:mt-16 lg:mt-20">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Waves" size={20} className="text-primary" />
              <span className="text-sm md:text-base">
                &copy; {new Date()?.getFullYear()} PaddleTurkiye. Tüm hakları saklıdır.
              </span>
            </div>
            <div className="flex items-center gap-4 md:gap-6 text-sm md:text-base text-muted-foreground">
              <button className="hover:text-primary transition-smooth">Gizlilik Politikası</button>
              <button className="hover:text-primary transition-smooth">Kullanım Şartları</button>
              <button className="hover:text-primary transition-smooth">İletişim</button>
            </div>
          </div>
        </div>
      </footer>
    </div>);

};

export default Login;